import { useNavigate } from 'react-router';
import { Menu, LogOut } from 'lucide-react';
import { useAuthStore } from '../../stores/auth.store';
import { useUIStore } from '../../stores/ui.store';
import { authService } from '../../services/auth.service';
import { sessionService } from '../../services/session.service';
import { Environment } from '../../config/environment';
import { version } from '../../../package.json';

declare const __BUILD_TIME__: string;

function formatBuildTime(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}.${pad(d.getHours())}${pad(d.getMinutes())}`;
}

function Header() {
  const user = useAuthStore((s) => s.user);
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);
  const navigate = useNavigate();

  async function handleLogout() {
    await authService.logout();
    sessionService.endSession();
    useAuthStore.getState().setUser(null);
    navigate('/login');
  }

  const envBadgeClass = Environment.isProd
    ? 'bg-red-100 text-red-700'
    : 'bg-yellow-100 text-yellow-700';

  return (
    <header className="flex h-12 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={toggleSidebar}
          className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
          aria-label="Toggle sidebar"
        >
          <Menu className="h-5 w-5" />
        </button>
        <span className="text-lg font-semibold text-gray-800">AssetsFlow Admin</span>
        <span className="font-mono text-xs text-gray-400">
          v{version}-{formatBuildTime(__BUILD_TIME__)}
        </span>
        <span
          className={`rounded-full px-2 py-0.5 text-xs font-bold ${envBadgeClass}`}
        >
          {Environment.label}
        </span>
      </div>

      <div className="flex items-center gap-4">
        {user?.email && <span className="text-sm text-gray-500">{user.email}</span>}
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
      </div>
    </header>
  );
}

export default Header;
